(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.BasketMenuPopover = {
    init: function() {
      return $('.basket-popover-toggle').on('click', this.toggleBasketPopover);
    },
    toggleBasketPopover: function(e) {
      var action, num_items_in_basket;
      e.preventDefault();
      if ($(".basket-popover").is(":hidden")) {
        action = "shown";
      } else {
        action = "hidden";
      }
      num_items_in_basket = $('.cart-item-count').text();
      $('.basket-popover').toggle();
      return echo_ga.track_event('basket', 'wide-toggle', action, num_items_in_basket);
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.CartDateAvailableDays = {
    init: function() {
      if ($("#date")[0]) {
        return this.initialize_datepicker();
      }
    },
    initialize_datepicker: function() {
      return $('#date').datepicker({
        dateFormat: 'dd-mm-yy',
        minDate: WildMeat.CartDateAvailableDays.earliest_day_offset(),
        beforeShowDay: function(date) {
          var day_being_shown, day_of_the_week, formatted_date, unavailable_dates;
          day_being_shown = [true, ''];
          formatted_date = moment(date).format('DD-MM-YYYY');
          day_of_the_week = moment(date).format('dddd');
          console.log(day_of_the_week);
          unavailable_dates = $('#unavailable_delivery_dates').text().split(/\n/);
          if ($.inArray(formatted_date, unavailable_dates) >= 0 || day_of_the_week === 'Saturday' || day_of_the_week === 'Sunday') {
            day_being_shown = [false, ''];
          }
          return day_being_shown;
        }
      });
    },
    earliest_day_offset: function() {
      var currentTime, day_of_the_week, min;
      min = 3;
      currentTime = new Date;
      day_of_the_week = moment(new Date).format('dddd');
      if (currentTime.getHours() < 11) {
        min = 2;
      }
      if (currentTime.getHours() > 14 && day_of_the_week === 'Friday') {
        min = 5;
      }
      if (day_of_the_week === 'Saturday') {
        min = 4;
      }
      if (day_of_the_week === 'Sunday') {
        min = 3;
      }
      return min;
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.CartDateValidation = {
    init: function() {
      if ($('#cartform')[0]) {
        return $('#cartform').on('submit', this.validateDeliveryDate);
      }
    },
    validateDeliveryDate: function() {
      var delivery_date, reformed_date, today;
      $('#date-manual-error').remove();
      reformed_date = WildMeat.CartDateValidation.get_date_from_user_entered_data();
      if (!WildMeat.CartDateValidation.isValidDate(reformed_date)) {
        return WildMeat.CartDateValidation.show_invalid_input();
      }
      delivery_date = moment(reformed_date);
      today = moment(new Date());
      if (!delivery_date.isAfter(today, 'day')) {
        return WildMeat.CartDateValidation.show_invalid_input();
      }
      if (WildMeat.CartDateValidation.outside_offset(delivery_date) || WildMeat.CartDateValidation.invalid_day_of_week(delivery_date) || WildMeat.CartDateValidation.is_available_date(delivery_date)) {
        return WildMeat.CartDateValidation.show_unavailable_date();
      }
    },
    isValidDate: function(d) {
      if (Object.prototype.toString.call(d) === "[object Date]") {
        if (isNaN(d.getTime())) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    show_error: function(error_mesage) {
      var error_message;
      error_message = $("<span id=\"date-manual-error\" class=\"manual-error\">" + error_mesage + "</span>");
      if ($('#date-manual-error')[0]) {
        $('#date-manual-error').replaceWith(error_message);
      } else {
        $('.date-picker').append(error_message);
      }
      return false;
    },
    show_invalid_input: function() {
      return WildMeat.CartDateValidation.show_error('The date must be valid (dd-mm-yyyy) and later than today.');
    },
    show_unavailable_date: function() {
      return WildMeat.CartDateValidation.show_error('The date is unavailable for delivery, please select an active date from the calendar.');
    },
    get_date_from_user_entered_data: function() {
      var delivery_date_parts, delivery_date_string, reformed_date;
      delivery_date_string = $('#date').val();
      delivery_date_parts = delivery_date_string.split("-");
      reformed_date = new Date(delivery_date_parts[2], delivery_date_parts[1] - 1, delivery_date_parts[0]);
      return reformed_date;
    },
    invalid_day_of_week: function(delivery_date) {
      var day_of_the_week;
      day_of_the_week = moment(delivery_date).format('dddd');
      return day_of_the_week === 'Sunday';
    },
    outside_offset: function(delivery_date) {
      var date_offset, next_available_date, today;
      date_offset = WildMeat.CartDateAvailableDays.earliest_day_offset();
      today = moment(new Date());
      next_available_date = moment(today).add(date_offset, 'days');
      return moment(delivery_date).isBefore(next_available_date, 'day');
    },
    is_available_date: function(delivery_date) {
      var unavailable_dates;
      delivery_date = moment(delivery_date).format("DD-MM-YYYY");
      unavailable_dates = $('#unavailable_delivery_dates').text().split(/\n/);
      return $.inArray(delivery_date, unavailable_dates) >= 0;
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.GoogleAnalytics = {
    track_event: function(category, action, label, value, field_object) {
      label || (label = '');
      value || (value = 0);
      field_object || (field_object = {});
      if (typeof ga !== "undefined" && ga !== null) {
        return ga('send', 'event', category, action, label, value, field_object);
      }
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.MenuBarNarrow = {
    init: function() {
      $('.slide-toggle').on('click', this.toggleMenus);
      return $('.slide-menu .dropdown').on('click', this.toggleSubMenu);
    },
    toggleMenus: function() {
      var menu_to_toggle;
      menu_to_toggle = $(this).data('toggle');
      echo_ga.track_event('navigation', 'mobile-toggle', menu_to_toggle);
      $(".slide-menu:not(" + menu_to_toggle + ")").hide();
      return $(menu_to_toggle).slideToggle('fast');
    },
    toggleSubMenu: function(e) {
      var action, element;
      e.stopPropagation();
      element = $(this).children('.dropdown')[0];
      if ($(element).is(":visible")) {
        action = "collapsed";
      } else {
        action = "expanded";
      }
      WildMeat.MenuBarNarrow.collapseAll(this);
      WildMeat.MenuBarNarrow.resetToggleClasses();
      if ($(this).children('.dropdown').length > 0) {
        e.preventDefault();
        $(this).children('.dropdown').slideToggle();
        return $(this).addClass(action);
      }
    },
    resetToggleClasses: function() {
      return $('.slide-menu .dropdown').removeClass('expanded collapsed');
    },
    collapseAll: function(element) {
      $(element).siblings().children('.dropdown').slideUp();
      return $('.slide-menu .dropdown').removeClass('expanded');
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.MenuBarWide = {
    init: function() {
      return $('.menu-bar-wide li').hover(this.toggleWideSubMenuShow, this.toggleWideSubMenuHide);
    },
    toggleWideSubMenuHide: function() {
      $(this).children('.dropdown').stop();
      return $(this).children('.dropdown').animate({
        opacity: 1.0
      }, 220, function() {
        return $(this).fadeOut('fast');
      });
    },
    toggleWideSubMenuShow: function() {
      return $(this).children('.dropdown').fadeIn('fast');
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.ParsleyFormValidation = {
    init: function() {
      if ($('.parsley')[0]) {
        return $('.parsley').parsley();
      }
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.ProductImageViewer = {
    init: function() {
      return $('.product-images .thumbnail a').on('click', this.toggleFeaturedImage);
    },
    toggleFeaturedImage: function() {
      return console.log("a thumbnail was clicked");
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.ProductQuantity = {
    init: function() {
      return $('.quantity-increment, .quantity-decrement').on('click', this.alterQuantity);
    },
    alterQuantity: function() {
      var alteration, current_value, new_value;
      if ($(this).hasClass('quantity-increment')) {
        alteration = 'increment';
      } else {
        alteration = 'decrement';
      }
      current_value = parseInt($(this).siblings('.item-quantity').val(), 10);
      if (alteration === 'increment') {
        new_value = current_value + 1;
      } else {
        new_value = current_value - 1;
      }
      if (new_value > 0) {
        $(this).siblings('.item-quantity').val(new_value);
        return echo_ga.track_event('pageinteraction', 'product-quantity', alteration, new_value);
      }
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.ProductSort = {
    init: function() {
      return $('#product-sort-options').on('change', this.sortProducts);
    },
    sortProducts: function() {
      var current_url, sort_option;
      if ($(this).val() !== "") {
        current_url = window.location.href;
        sort_option = $(this).val();
        return window.location.href = current_url + $(this).val();
      }
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.ProductTabs = {
    init: function() {
      return $('.tab-bar .tab').on('click', this.toggleTabs);
    },
    toggleTabs: function() {
      var target;
      $('.tab-bar .tab').removeClass('active-tab');
      target = $(this).data('target');
      $(this).addClass('active-tab');
      echo_ga.track_event('pageinteraction', 'product-tabs', target);
      return WildMeat.ProductTabs.showTab(target);
    },
    showTab: function(target) {
      $('.tab-content').removeClass('active-tab-content');
      return $(target).addClass('active-tab-content');
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.RecipeFilter = {
    init: function() {
      return $('#recipe-filter').on('change', this.sortProducts);
    },
    sortProducts: function() {
      if ($(this).val() !== "") {
        return window.location.href = $(this).val();
      }
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.ScrollAnimation = {
    init: function() {
      return $('a[href^="#"]').on('click', this.animateScroll);
    },
    animateScroll: function(e) {
      var $target, target;
      e.preventDefault();
      target = this.hash;
      $target = $(target);
      return $('html, body').stop().animate({
        'scrollTop': $target.offset().top - 60
      }, 500, 'swing', function() {
        return window.location.hash = target;
      });
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.SearchResults = {
    init: function() {
      if ($('.search-results-count')[0]) {
        return this.logSearchResultsTotal();
      }
    },
    logSearchResultsTotal: function() {
      var num_of_results;
      num_of_results = $('.search-results-count').text();
      return echo_ga.track_event('search', 'no. of search results', num_of_results);
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.ShowProductReviews = {
    init: function() {
      var all_elems, review_summary;
      if ($('.spr-summary')[0]) {
        review_summary = $('.spr-summary').clone();
        review_summary.removeAttr('itemscope itemtype');
        all_elems = review_summary.find("*").toArray();
        $(all_elems).each(function() {
          return $(this).removeAttr('itemscope itemprop itemtype content');
        });
        review_summary.addClass('product-cloned-reviews');
        review_summary.find('.spr-summary-actions').remove();
        return $('.product-title').append(review_summary);
      }
    }
  };

}).call(this);

(function() {
  window.WildMeat = window.WildMeat || {};

  WildMeat.SidebarToggle = {
    init: function() {
      return $('.btn-page-sidebar-toggle').on('click', this.toggleSidebar);
    },
    toggleSidebar: function() {
      var action;
      if ($(".page-sidebar").is(":hidden")) {
        action = "expanded";
      } else {
        action = "collapsed";
      }
      echo_ga.track_event('navigation', 'page-sidebar-toggle', action);
      WildMeat.SidebarToggle.resetSidebarClasses(this);
      $(this).addClass(action);
      return $('.page-sidebar').slideToggle();
    },
    resetSidebarClasses: function(sidebarToggler) {
      return $(sidebarToggler).removeClass('expanded collapsed');
    }
  };

}).call(this);

(function() {
  $(function() {
    window.echo_ga = WildMeat.GoogleAnalytics;
    WildMeat.MenuBarNarrow.init();
    WildMeat.MenuBarWide.init();
    WildMeat.SidebarToggle.init();
    WildMeat.SearchResults.init();
    WildMeat.ProductImageViewer.init();
    WildMeat.ProductSort.init();
    WildMeat.ProductTabs.init();
    WildMeat.ProductQuantity.init();
    WildMeat.BasketMenuPopover.init();
    WildMeat.ScrollAnimation.init();
    WildMeat.ParsleyFormValidation.init();
    WildMeat.CartDateValidation.init();
    WildMeat.RecipeFilter.init();
    WildMeat.CartDateAvailableDays.init();
    return WildMeat.ShowProductReviews.init();
  });

}).call(this);
